import { Env } from '@env';

import type { Address } from '@/api/subscriptions/types';
import { parseAddressComponents } from '@/core/utils';

export const reverseGeocode = async (
  lat: number,
  lng: number
): Promise<Address | null> => {
  const api = `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&key=${Env.GOOGLE_APP_API_KEY}`;
  const controller = new AbortController();
  const timeoutId = setTimeout(() => controller.abort(), 3000);

  try {
    const response = await fetch(api, { signal: controller.signal });
    const data = await response.json();

    if (!data.results?.length) return null;

    const addressComponents = data.results[0].address_components;
    const city = addressComponents.find((c: { types: string[] }) =>
      c.types.includes('locality')
    )?.long_name;
    const state = addressComponents.find((c: { types: string[] }) =>
      c.types.includes('administrative_area_level_1')
    )?.long_name;
    const zipcode = addressComponents.find((c: { types: string[] }) =>
      c.types.includes('postal_code')
    )?.long_name;

    return {
      addressComponents,
      description: data.results[0].formatted_address,
      placeId: data.results[0].place_id,
      latitude: lat,
      longitude: lng,
      city,
      state,
      zipcode,
      ...parseAddressComponents(addressComponents),
    };
  } catch (error) {
    console.error(error);
    return null;
  } finally {
    clearTimeout(timeoutId);
  }
};
